import React, { useEffect, useRef, useState } from 'react'
import { CFormTextarea, CCard, CButton, CSpinner, CBadge, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CCardBody } from '@coreui/react'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api'
import Carder from '../../components/shared/Carder'
import GetDiagnosisHighlights from '../../components/shared/GetDiagnosisHighlights'
import ImagingInformation from '../../services/general/ImagingAPI.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import HighlightedText from '../../components/shared/HighlightedText'
import Graytextarea from '../../components/Graytextarea'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const PatientPersonalHistory = ({ patientID, loading, updatePatientDiagnosis, saveTreatsShell, diagnosis, setLoading, Notes, removeDiagnosisIdFromNote, setNotes, histories, setHistories, activeTab, setActiveTab, setDiagnosisAddedPinger, noteStructureRef, addDiagnosisIdsToNote }) => {
  // const [textInput, setTextInput] = useState('');
  const [textInput, setTextInput] = useState({
    pmhx: '',
    pshx: 'No surgical hx found',
    fh: 'Noncontributory',
    sh: 'Pt denies any hx of tobacco, alcohol or any illict drug use',
  })

  const [modalVisible, setModalVisible] = useState(false)
  const [currentDate, setCurrentDate] = useState('')
  const [patientIdEdit, setPatientIdEdit] = useState(null)
  const [imagingTypeList, setImagingTypeList] = useState([])
  const [possibleDiagnosis, setPossibleDiagnosis] = useState([])
  const [loadings, setLoadings] = useState(false)
  const [diagnosisData, setDiagnosisData] = useState([])
  const [diagnosisModalVisible, setDiagnosisModalVisible] = useState(false)
  const detectedKeywordsRef = useRef(new Set())
  const [currentTypeTab, setCurrentTypeTab] = useState('')
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [editableIdExistIntoNotes, setEditableIdExistIntoNotes] = useState({})
  const [showEditHtml, setShowEditHtml] = useState(false)
  const [tempHtmlContent, setTempHtmlContent] = useState('')

  const historyTypeMapping = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  useEffect(() => {
    setCurrentDate(getFormattedDate())
    getDiagnosisData()
    // loadHistories();
  }, [patientID])

  const handleInputChange = (event, type) => {
    // setTextInput(event.target.value);
    setTextInput((prev) => ({
      ...prev,
      [type]: event.target.value,
    }))
  }

  const addHistoryNote = async (type) => {
    const activeType = type || activeTab
    const noteText = textInput[activeType]?.trim()

    if (!noteText) {
      toast.error('Please fill the history', toastConfig)
      return
    }

    setLoadings(true)
    try {
      const historyType = historyTypeMapping[activeType]

      if (patientIdEdit) {
        const allHistoryRecordForActiveTab = histories[activeType]
        const newListOfHistoryRecord = allHistoryRecordForActiveTab.map((item) => {
          if (item.Id === patientIdEdit) {
            return { ...item, [historyType]: noteText }
          }
          return item
        })
        // setHistories(prevHistories => ({
        //     ...prevHistories,
        //     [type]: newListOfHistoryRecord
        // }));
        await getPatientPersonalHistory('UPDATE', patientID, historyType, currentDate, noteText, patientIdEdit)
        setTextInput({
          pmhx: '',
          pshx: '',
          fh: '',
          sh: '',
        })
        setPatientIdEdit(null)
        toast.success('Successfully Updated', toastConfig)
        await getData()
        await populateExistIdHistoryMatchingMetadata()
        return
      }

      const newNote = { Date: currentDate }
      newNote[historyType] = noteText
      // setHistories(prevHistories => ({
      //     ...prevHistories,
      //     [type]: [newNote, ...prevHistories[type]]
      // }));

      await getPatientPersonalHistory('INSERT', patientID, historyType, '', noteText)
      let allData = await getPatientPersonalHistory('GET', patientID, historyType, '')
      let formattedData = JSON.parse(allData?.d)
      formattedData = formattedData?.Data
      if (formattedData.length > 0) {
        const latestHistoryId = formattedData[formattedData.length - 1]?.Id
        noteStructureRef.current = {
          ...noteStructureRef.current,
          metadata: {
            ...noteStructureRef.current.metadata,
            [historyType]: latestHistoryId || '',
          },
        }
        setEditableIdExistIntoNotes((p) => ({
          ...p,
          [historyType]: latestHistoryId,
        }))
        toast.success('History added successfully', toastConfig)
        await saveTreatsShell(false)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadings(false)
    }
  }

  const handleDeletePatientHistory = async () => {
    const historyType = historyTypeMapping[activeTab]
    await getPatientPersonalHistory('DELETE', patientID, historyType, '', textInput[activeTab], deleteVisibleId?.toString()) // for update
    await getData()
    setDeleteVisibleId(null)
  }

  const onResetCancel = () => {
    setTextInput({
      pmhx: '',
      pshx: '',
      fh: '',
      sh: '',
    })
    setPatientIdEdit(null)
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    return `${mm}/${dd}/${yyyy}`
  }

  const getData = async () => {
    const historyType = historyTypeMapping[activeTab]
    let allData
    if (historyType) {
      allData = await getPatientPersonalHistory('GET', patientID, historyType, '')
      const formattedData = JSON.parse(allData?.d)
      let newHistories = {}
      if (formattedData) {
        newHistories = {
          ...histories,
          [activeTab]: formattedData.Data,
        }
        setHistories((prevHistories) => ({
          ...prevHistories,
          [activeTab]: formattedData.Data,
        }))
      }
      if (formattedData) {
        let temp = {}
        Object.keys(newHistories).map((obj) => {
          if (newHistories[obj].length > 0) {
            let objList = newHistories[obj]
            let tab = historyTypeMapping[obj]
            temp[obj] = objList[objList.length - 1][tab]
          }
        })
        // localStorage.setItem('patientHistories', JSON.stringify(temp))
        return newHistories
      }
    }
    // return allData; // tunring this off find where i can use it if somethin went wrong
  }

  const handleEditHistoryPatient = (history) => {
    if (!history) return
    setModalVisible(true)
    setPatientIdEdit(history?.Id)

    // setTextInput(history[historyTypeMapping[activeTab]]);
    setTextInput((prev) => ({
      ...prev,
      [activeTab]: history[historyTypeMapping[activeTab]] || '',
    }))
  }

  useEffect(() => {
    getDataImaging()
    getData()
  }, [patientID, activeTab])

  useEffect(() => {
    setPatientIdEdit(null)
  }, [activeTab])

  const getDataImaging = async () => {
    try {
      const data = await ImagingInformation('GET_ALL')
      if (data) {
        const formattedData = JSON.parse(data.d)?.Data
        const allFormattedData = formattedData
          .filter((item) => item.Keywords !== '')
          .map((item) => {
            return {
              ...item,
              Keywords: JSON.parse(JSON.parse(item.Keywords)),
            }
          })
        setImagingTypeList(allFormattedData)
      }
    } catch (error) {
      console.error('Error fetching imaging data', error)
    }
  }

  const getDiagnosisData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    setDiagnosisData(data.Data)
  }

  const addDiagnosis = () => {
    let newDiagnosis = possibleDiagnosis.map((obj) => {
      return obj.Name.trim()
    })

    let historyDiagnosis = newDiagnosis.reduce((acc, item) => {
      let existingData = noteStructureRef.current?.information?.[item] || []

      if (!existingData.includes('Patient History')) {
        acc[item] = [...existingData, 'Patient History']
      } else {
        acc[item] = existingData
      }

      return acc
    }, {})

    noteStructureRef.current = {
      ...noteStructureRef.current,
      information: {
        ...noteStructureRef.current.information,
        ...historyDiagnosis,
      },
    }

    newDiagnosis = newDiagnosis.join(',')
    const diagnosisIds = possibleDiagnosis.map((item) => item.id)
    addDiagnosisIdsToNote(diagnosisIds)
    updatePatientDiagnosis(patientID, newDiagnosis)
    setDiagnosisModalVisible(false)
    setDiagnosisAddedPinger((p) => !p)
    if (typeof saveTreatsShell === 'function') {
      saveTreatsShell(false)
    }
  }

  const handleDiagnosis = async (type) => {
    setCurrentTypeTab(type)
    filterDiagnosis(type)
    await getData()
  }

  const handleRemoveDiagnosis = (indexToRemove) => {
    setPossibleDiagnosis((prevDiagnosis) => prevDiagnosis.filter((_, index) => index !== indexToRemove))
  }

  // const filterDiagnosis = () => {
  //     const sanitizedImpression = textInput[activeTab].replace(/[^a-zA-Z0-9\s]/g, '');

  //     // Split the sanitized impression into keywords
  //     const inputKeywords = sanitizedImpression.toLowerCase().split(/\s+/).filter(keyword => keyword.trim() !== '');
  //     // const inputKeywords = textInput.toLowerCase().split(/\s+/).filter(keyword => keyword.trim() !== '');
  //     detectedKeywordsRef.current.clear(); // Clear previous keywords
  //     const possibleDiagnosis = diagnosisData.filter(diagnosis => {

  //         const diagnosisKeywords = (diagnosis?.Keywords || '').split(',').map(keyword => keyword.trim().toLowerCase());
  //         let match = true

  //         diagnosisKeywords.find((diagnosisKeyword) => {
  //             match = true
  //             const diagnosisKeywordParts = diagnosisKeyword.split(/\s+/);
  //             if (diagnosisKeywordParts.length > 1) {

  //                 let foundIndex = inputKeywords.indexOf(diagnosisKeywordParts[0]);
  //                 if (foundIndex != -1) {
  //                     for (let i = 0; i <= diagnosisKeywordParts.length - 1; i++) {
  //                         if (inputKeywords.length < foundIndex + i) {
  //                             match = false
  //                             break
  //                         }
  //                         if (diagnosisKeywordParts[i] != inputKeywords[foundIndex + i]) {

  //                             match = false
  //                             break
  //                         }

  //                     }
  //                 } else {
  //                     match = false

  //                 }

  //             } else {

  //                 let foundKeyword = inputKeywords.includes(diagnosisKeyword);
  //                 if (!foundKeyword) {
  //                     match = false
  //                 } else {
  //                     match = true
  //                 }
  //             }
  //             if (match) {
  //                 return true

  //             }
  //         })
  //         if (match) {
  //             diagnosisKeywords.forEach(keyword => detectedKeywordsRef.current.add(keyword));
  //         }
  //         return match

  //     });
  //     const possibleDiagnosisWithoutExisting = possibleDiagnosis.filter(keyword => !diagnosis.includes(keyword.Name.trim()))
  //     setPossibleDiagnosis(possibleDiagnosisWithoutExisting);
  // };

  const filterDiagnosis = (type, defaultOpen = false) => {
    const activeType = type || activeTab
    const sanitizedImpression = textInput[activeType].replace(/[^a-zA-Z0-9\s]/g, '')

    // Split the sanitized impression into keywords
    const inputKeywords = sanitizedImpression
      .toLowerCase()
      .split(/\s+/)
      .filter((keyword) => keyword.trim() !== '')

    detectedKeywordsRef.current.clear() // Clear previous keywords
    const possibleDiagnosis = diagnosisData.filter((diagnosis) => {
      const diagnosisKeywords = (diagnosis?.Keywords || '').split(',').map((keyword) => keyword.trim().toLowerCase())
      let match = true

      diagnosisKeywords.find((diagnosisKeyword) => {
        match = true
        const diagnosisKeywordParts = diagnosisKeyword.split(/\s+/)

        if (diagnosisKeywordParts.length > 1) {
          let foundIndex = inputKeywords.indexOf(diagnosisKeywordParts[0])
          if (foundIndex != -1) {
            for (let i = 0; i <= diagnosisKeywordParts.length - 1; i++) {
              if (inputKeywords.length < foundIndex + i) {
                match = false
                break
              }
              if (diagnosisKeywordParts[i] != inputKeywords[foundIndex + i]) {
                match = false
                break
              }
            }
          } else {
            match = false
          }
        } else {
          let foundKeyword = inputKeywords.includes(diagnosisKeyword)
          if (!foundKeyword) {
            match = false
          } else {
            match = true
          }
        }
        if (match) {
          return true
        }
      })
      if (match) {
        diagnosisKeywords.forEach((keyword) => detectedKeywordsRef.current.add(keyword))
      }
      return match
    })

    let result = possibleDiagnosis.filter((item) => !diagnosis.includes(item.Name.trim()))
    if (result.length > 0) {
      setDiagnosisModalVisible(true)
      setPossibleDiagnosis(result)
      setLoading(false)
    } else {
      addDiagnosis()
      addHistoryNote(activeType)
      setLoading(false)
    }
  }

  //     useEffect(() => {
  //     if (noteStructureRef.current?.metadata) {
  //       const {
  //         MedicalHistory,
  //         FamilyHistory,
  //         SurgicalHistory,
  //         SocialHistory,
  //       } = noteStructureRef.current.metadata;

  //       setEditableIdExistIntoNotes({
  //         MedicalHistory,
  //         FamilyHistory,
  //         SurgicalHistory,
  //         SocialHistory,
  //       });
  //         editableIdExistIntoNotes,
  //         MedicalHistory,
  //         FamilyHistory,
  //         SurgicalHistory,
  //         SocialHistory,)
  //       if(editableIdExistIntoNotes[historyTypeMapping[activeTab]]){
  //         const idToFind = editableIdExistIntoNotes[historyTypeMapping[activeTab]]
  //         const currentTabItems = histories[activeTab]
  //         // const findCurrentHistoryForTabThatEditable =
  //         const findCurrentHistoryForTabThatEditable = currentTabItems.find(item => item.Id === idToFind)
  //         if(findCurrentHistoryForTabThatEditable){
  //             setTextInput(prev => ({
  //                 ...prev,
  //                 [activeTab]: findCurrentHistoryForTabThatEditable[historyTypeMapping[activeTab]] || ''
  //             }));
  //           handleEditHistoryPatient(findCurrentHistoryForTabThatEditable)
  //         }
  //       }
  //     }
  //   }, [noteStructureRef.current?.metadata]);

  // First effect: just sets the state

  useEffect(() => {
    if (noteStructureRef.current?.metadata) {
      const { MedicalHistory, FamilyHistory, SurgicalHistory, SocialHistory } = noteStructureRef.current.metadata

      setEditableIdExistIntoNotes({
        MedicalHistory,
        FamilyHistory,
        SurgicalHistory,
        SocialHistory,
      })
    }
  }, [noteStructureRef.current?.metadata])

  const populateExistIdHistoryMatchingMetadata = async () => {
    const idToFind = editableIdExistIntoNotes[historyTypeMapping[activeTab]]
    const updatedHistoryItems = await getData()
    if (idToFind) {
      const currentTabItems = updatedHistoryItems[activeTab]
      const editableItem = currentTabItems.find((item) => item.Id === idToFind)

      if (editableItem) {
        setTextInput((prev) => ({
          ...prev,
          [activeTab]: editableItem[historyTypeMapping[activeTab]] || '',
        }))
        handleEditHistoryPatient(editableItem)
      } else {
        setPatientIdEdit(null)
      }
    } else {
      setPatientIdEdit(null)
    }
  }

  useEffect(() => {
    populateExistIdHistoryMatchingMetadata()
  }, [editableIdExistIntoNotes, activeTab])

  return (
    <>
      {/* delete modal */}
      <CModal visible={deleteVisibleId}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setDeleteVisibleId(null)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
          <CButton onClick={handleDeletePatientHistory} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal className="dashboard-dark-modal patient-theme-modal patient-labs-modal" size="lg" visible={diagnosisModalVisible} onClose={() => setDiagnosisModalVisible(false)}>
        <CModalHeader onClose={() => setDiagnosisModalVisible(false)}>
          <CModalTitle>Diagnosis Details</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="d-flex">
            <div style={{ minWidth: '50%', maxWidth: '50%', width: '50%' }} className="flex-fill me-3 text-display">
              <p style={{ whiteSpace: 'pre-line' }}></p>
              <HighlightedText text={textInput[activeTab]} keywords={Array.from(detectedKeywordsRef.current)}></HighlightedText>
            </div>
            <div className="flex-fill">
              <h5>Detected Diagnosis</h5>
              {possibleDiagnosis.map((diagnosis, index) => (
                <CBadge key={index} color="info" className="me-2 mr-1 mb-1 text-white" style={{ cursor: 'pointer' }} onClick={() => handleRemoveDiagnosis(index)}>
                  {diagnosis.Name}
                </CBadge>
              ))}
              <hr />
              <h5>Existing Diagnosis</h5>
              {diagnosis?.map((diagnosisItem, index) => (
                <CBadge key={index} color="primary" className="me-2 mr-1 mb-1">
                  {diagnosisItem}
                </CBadge>
              ))}
            </div>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            variant="outline"
            color="primary"
            onClick={async () => {
              addDiagnosis()
              addHistoryNote(activeTab)
              await getData()
            }}
          >
            Add Diagnosis
          </CButton>
          <CButton
            variant="outline"
            color="secondary"
            onClick={async () => {
              addHistoryNote(activeTab)
              setModalVisible(false)
              setDiagnosisModalVisible(false)
              setTextInput({
                pmhx: '',
                pshx: '',
                fh: '',
                sh: '',
              })
              await getData()
            }}
          >
            Continue without adding
          </CButton>
        </CModalFooter>
      </CModal>

      <div>
        <CNav variant="pills" className="justify-content-center" style={{ gap: '5px' }}>
          <CNavItem>
            <CNavLink active={activeTab === 'pmhx'} onClick={() => setActiveTab('pmhx')}>
              Past Medical History (PMHx)
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeTab === 'pshx'} onClick={() => setActiveTab('pshx')}>
              Past Surgical History (PSHx)
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeTab === 'fh'} onClick={() => setActiveTab('fh')}>
              Family History (FH)
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeTab === 'sh'} onClick={() => setActiveTab('sh')}>
              Social History (SH)
            </CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent>
          {['pmhx', 'pshx', 'fh', 'sh'].map((type) => (
            <CTabPane key={type} visible={activeTab === type} className="mt-4">
              {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                  <CSpinner color="primary" />
                </div>
              ) : (
                <>
                  {/* <div className="mb-3">Date: {currentDate}</div> */}
                  <Graytextarea type="text" placeholder="Enter history of patient here..." id="textInput" value={textInput[type]} rows={3} required onChange={(event) => handleInputChange(event, type)} />
                  <div className="d-flex mt-4 align-items-center gap-2">
                    <GetDiagnosisHighlights
                      diagnosis={diagnosis}
                      removeDiagnosisIdFromNote={removeDiagnosisIdFromNote}
                      getData={getData}
                      addDiagnosisIdsToNote={addDiagnosisIdsToNote}
                      textButtonForAddDiagnosis={'Add Diagnosis & History'}
                      showCustomButton={true}
                      toggleItsModalWhenCustomButton={true}
                      alsoRunThisWhenDiagnosisAdd={() => {
                        addHistoryNote(type)
                      }}
                      customButtonClick={async () => {
                        // addDiagnosis()
                        addHistoryNote(type)
                        await getData()
                        // handleDiagnosis()
                        // setCurrentTypeTab(type)
                      }}
                      customButtonText={'Add History'}
                      setDiagnosisAddedPinger={setDiagnosisAddedPinger}
                      patientID={patientID}
                      textInput={textInput[activeTab]}
                    />
                    <CButton
                      className="patient-page-action-btn"
                      onClick={() => {
                        setCurrentTypeTab(type)
                        addHistoryNote(type)
                      }}
                      // onClick={() => addHistoryNote(type)}
                      variant="outline"
                      color="primary"
                    >
                      {loadings ? (
                        <CSpinner component="span" size="sm" aria-hidden="true" />
                      ) : (
                        <>{patientIdEdit !== null ? 'Update' : 'Add'}</>
                      )}
                    </CButton>
                    {/* {patientIdEdit !== null && <CButton onClick={onResetCancel}>Cancel</CButton>} */}
                  </div>
                  {histories[type]
                    ?.slice()
                    .reverse()
                    ?.map((obj, index) => {
                      const isEditable = editableIdExistIntoNotes[historyTypeMapping[activeTab]] === obj.Id
                      return (
                        <Carder
                          deleteFunc={
                            isEditable
                              ? () => {
                                  setDeleteVisibleId(obj.Id)
                                }
                              : null
                          }
                          editFunc={
                            isEditable
                              ? () => {
                                  handleEditHistoryPatient(obj)
                                }
                              : null
                          }
                          key={index}
                          style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}
                          className=""
                        >
                          <CCardBody className="">
                            <div className="p-1">
                              {' '}
                              <p className="p-0 m-0" style={{ whiteSpace: 'pre-line' }}>
                                {obj[historyTypeMapping[activeTab]]}
                              </p>{' '}
                            </div>
                          </CCardBody>
                        </Carder>
                      )
                    })}

                  {noteStructureRef?.current?.freeTypesEverything?.historyFreetype?.[historyTypeMapping[activeTab]] && (
                    <div className="mt-2">
                      <div
                        className="p-4 patient-theme-old-data patient-theme-old-data--readonly"
                        onClick={() => {
                          setTempHtmlContent(noteStructureRef?.current?.freeTypesEverything?.historyFreetype?.[historyTypeMapping[activeTab]] || '')
                          // setShowEditHtml(true)
                        }}
                        dangerouslySetInnerHTML={{ __html: noteStructureRef?.current?.freeTypesEverything?.historyFreetype?.[historyTypeMapping[activeTab]] }}
                      ></div>
                    </div>
                  )}

                  {/* {[...histories[type]]?.reverse()?.map((obj, index) => {
                                        return (
                                            <Carder
                                                key={obj.Id}
                                                deleteFunc={
                                                    editableIdExistIntoNotes[historyTypeMapping[activeTab]] === obj.Id
                                                        ? () => setDeleteVisibleId(obj.Id)
                                                        : null
                                                }
                                                editFunc={
                                                    editableIdExistIntoNotes[historyTypeMapping[activeTab]] === obj.Id
                                                        ? () => handleEditHistoryPatient(obj)
                                                        : null
                                                }
                                                style={{
                                                    borderRadius: '1rem',
                                                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                <CCardBody>
                                                    <div className="p-1">
                                                        <p className="p-0 m-0" style={{ whiteSpace: 'pre-line' }}>
                                                            {obj[historyTypeMapping[activeTab]]}
                                                        </p>
                                                    </div>
                                                </CCardBody>
                                            </Carder>
                                        )
                                    })} */}
                </>
              )}
            </CTabPane>
          ))}
        </CTabContent>
      </div>
      <CModal size="lg" visible={showEditHtml} onClose={() => setShowEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Histories Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  historyFreetype: {
                    ...noteStructureRef.current?.freeTypesEverything?.historyFreetype,
                    [historyTypeMapping[activeTab]]: tempHtmlContent,
                  },
                },
              }
              saveTreatsShell(false)
              setShowEditHtml(false)
              setTempHtmlContent('')
            }}
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientPersonalHistory
